export default __webpack_public_path__ + "static/081-95042c16d64f8324a60bc10cd22897e9.jpg";